export const DatenschutzPage = () => {
  return (
    <main data-testid="datenschutz-page" className="bg-[#08080a] min-h-screen pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-pink-brand mb-4">Rechtliches</p>
        <h1 className="font-display font-bold text-4xl md:text-5xl text-white tracking-tight mb-12">Datenschutzerklärung</h1>

        <div className="space-y-10 text-neutral-300 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">1. Verantwortliche Stelle</h2>
            <p>
              Verantwortlich für die Datenbearbeitung auf dieser Website ist:<br /><br />
              Vollmermontagen GmbH<br />
              Hinwilerstrasse 11<br />
              8626 Ottikon, Schweiz<br />
              E-Mail: r.vollmermontagen@gmail.com
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">2. Grundsatz</h2>
            <p>
              Der Schutz Ihrer Daten ist uns wichtig. Wir bearbeiten Personendaten im Einklang mit dem
              Schweizer Datenschutzgesetz (revDSG). Auf dieser Website werden nur jene Daten erhoben,
              die für den Betrieb und die Kontaktaufnahme notwendig sind.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">3. Kontaktformular</h2>
            <p>
              Wenn Sie uns über das Kontaktformular eine Anfrage senden, bearbeiten wir die von Ihnen
              angegebenen Daten (Name, E-Mail-Adresse, Nachricht), um Ihre Anfrage zu beantworten.
              Die Daten werden in einer Datenbank gespeichert und zusätzlich per E-Mail an uns
              übermittelt. Eine Weitergabe an Dritte erfolgt nicht.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">4. Speicherdauer</h2>
            <p>
              Wir speichern Ihre Anfragen nur so lange, wie es für die Bearbeitung und allfällige
              Rückfragen notwendig ist, respektive wie es gesetzliche Aufbewahrungspflichten verlangen.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">5. Cookies und lokale Speicherung</h2>
            <p>
              Diese Website verwendet keine Tracking- oder Analyse-Cookies. Einzig Ihre gewählte
              Sprache (Deutsch, Englisch oder Französisch) wird lokal in Ihrem Browser gespeichert,
              damit die Website bei Ihrem nächsten Besuch in derselben Sprache erscheint.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">6. Dienstleister</h2>
            <p>
              Für den Versand von E-Mail-Benachrichtigungen aus dem Kontaktformular setzen wir einen
              technischen Dienstleister (E-Mail-Versanddienst) ein. Dabei werden die im Formular
              angegebenen Daten ausschliesslich zum Zweck der Übermittlung verarbeitet.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">7. Ihre Rechte</h2>
            <p>
              Sie haben jederzeit das Recht auf Auskunft über die bei uns gespeicherten Personendaten,
              auf Berichtigung, Löschung sowie auf Einschränkung der Bearbeitung. Wenden Sie sich dazu
              einfach an r.vollmermontagen@gmail.com.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-semibold text-white mb-3">8. Änderungen</h2>
            <p>
              Wir können diese Datenschutzerklärung jederzeit anpassen. Es gilt die jeweils auf dieser
              Website veröffentlichte Version.
            </p>
            <p className="mt-4 text-sm text-neutral-500">Stand: August 2026</p>
          </section>
        </div>
      </div>
    </main>
  );
};
